var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgExternalCacheStandard = function SvgExternalCacheStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 21.062v5.009a3.433 3.433 0 01-3.429 3.429H13.928a3.433 3.433 0 01-3.428-3.429V13.928a3.433 3.433 0 013.428-3.428h5.01v2h-5.01a1.43 1.43 0 00-1.428 1.428v12.143a1.43 1.43 0 001.428 1.429h12.143a1.43 1.43 0 001.429-1.429v-5.009zM26.162 19h-3.748l6.293-6.293-1.414-1.414L21 17.586v-3.747h-2V21h7.162z",
    fill: "#fabc3c"
  })));
};
export default SvgExternalCacheStandard;